
import { Component, Prop, Mixins } from 'vue-property-decorator';
import AvisoAlCerrar from '@/mixins/AvisoAlCerrar';
import AvisoSinGuardar from '@/components/core/AvisoSinGuardar.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ProviderService from '@/services/ProviderService';
import Provider from '@/models/provider';
import ApiHelper from '@/helpers/api-helper';
import CargandoFicha from '@/components/core/CargandoFicha.vue';

@Component({
	components: {
		AvisoSinGuardar,
		CargandoFicha,
		ValidationProvider,
		ValidationObserver,
	},
})
export default class ProviderForm extends Mixins(AvisoAlCerrar) {
	@Prop({ default: null, required: true }) private edit_id;

	$refs!: {
		obs: InstanceType<typeof ValidationObserver>;
	};

	private loading = false;
	private cargaFallida = false;
	private formTitle = '';
	private provider: Provider = new Provider();

	/** N-291 (T5b): lo que GUARDAR mandaría (las tablas de precios comparten el array con el modelo). */
	loQueSeGuardaria() {
		return JSON.stringify(this.provider);
	}

	mounted() {
		if (this.edit_id) {
			this.loading = true;
			this.formTitle = 'Edit provider';
			ProviderService.get(this.edit_id)
				.then(res => {
					if (res.status === 200) {
						this.provider = Provider.copy(res.data);
						this.loading = false;
						this.fotoSinCambios();
					}
				})
				.catch(error => {
					this.cargaFallida = true;
					ApiHelper.handleErrors(error, {}, this.$bus);
				});
		} else {
			this.formTitle = 'New provider';
			this.fotoSinCambios();
		}
	}

	async create() {
		const component = this;
		const validForm = await this.$refs['obs'].validate();
		if (validForm) {
			ProviderService.create(this.provider)
				.then(res => {
					if (res.status === 201) {
						this.$emit('saved');
					}
				})
				.catch(error => {
					ApiHelper.handleErrors(error, component.$refs['obs'], this.$bus);
				});
		}
	}

	async update() {
		const component = this;
		const validForm = await this.$refs['obs'].validate();
		if (validForm) {
			ProviderService.update(this.provider)
				.then(res => {
					if (res.status === 200) {
						this.$emit('saved');
					}
				})
				.catch(error => {
					ApiHelper.handleErrors(error, component.$refs['obs'], this.$bus);
				});
		}
	}
}
